import { TermsAndConditionsModel } from "src/app/models/common/terms-and-conditions.model";
import { ColorPreference, ContainerCondition, ContainerSizeType, CreatedBy, IBaseQuoteModel, ITradeQuoteItemModel, LocationModel, QuoteChargeMaster, QuoteChargeMasterError, UploadedDocument } from "../base-quote.model";

export class TradeQuoteItemError {
    id: string[];
    requirement: string[];
    quantity: string[];
    price_currency: string[];
    price: string[];
    negotiation_percent: string[];
    min_manufacturing_year: string[];
    max_manufacturing_year: string[];
    pickup_ready_date: string[];
    storage_charge_currency: string[];
    storage_charge: string[];
    free_storage_days: string[];
    csc_revalidation_required: string[];
    csc_validation_included: string[];
    is_procurement: string[];
    csc_revalidation_charge_currency: string[];
    csc_revalidation_charge: string[];
    created_by: string[];
    quote: string[];
    color_preference: string[];
    container_size_type: string[];
    container_condition: string[];
    purchase_locations: string[];
    container_images: string[];
    purpose: string[];
    ad_hoc_charges: QuoteChargeMasterError[]

    constructor() {
        this.id = [];
        this.requirement = [];
        this.quantity = [];
        this.price_currency = [];
        this.price = [];
        this.negotiation_percent = [];
        this.min_manufacturing_year = [];
        this.max_manufacturing_year = [];
        this.pickup_ready_date = [];
        this.storage_charge_currency = [];
        this.storage_charge = [];
        this.free_storage_days = [];
        this.csc_revalidation_required = [];
        this.csc_validation_included = [];
        this.is_procurement = [];
        this.csc_revalidation_charge_currency = [];
        this.csc_revalidation_charge = [];
        this.color_preference = [];
        this.created_by = [];
        this.quote = [];
        this.container_size_type = [];
        this.container_condition = [];
        this.purchase_locations = [];
        this.container_images = [];
        this.purpose = [];
        this.ad_hoc_charges = [];
    }
}

export class TradeQuoteError {
    quote_items: TradeQuoteItemError[];
    quote_valid_till: string[];
    uploaded_documents: string[];
    remarks: string[];
    terms_and_condition_text: string[];
    terms_and_condition_fk: string[];
    ad_hoc_charges: QuoteChargeMasterError[];

    constructor() {
        this.quote_items = [new TradeQuoteItemError()];
        this.quote_valid_till = [];
        this.uploaded_documents = [];
        this.remarks = [];
        this.terms_and_condition_text = [];
        this.terms_and_condition_fk = [];
    }

    patchErrors(errors) {
        this.quote_items = errors != null && errors.quote_items?.length ? errors.quote_items : [new TradeQuoteItemError()];
        this.quote_valid_till = errors != null && errors.quote_valid_till ? errors.quote_valid_till : [];
        this.uploaded_documents = errors != null && errors.uploaded_documents ? errors.uploaded_documents : [];
        this.remarks = errors != null && errors.remarks ? errors.remarks : [];
        this.terms_and_condition_text = errors != null && errors.terms_and_condition_text ? errors.terms_and_condition_text : [];
        this.terms_and_condition_fk = errors != null && errors.terms_and_condition_fk ? errors.terms_and_condition_fk : [];
        this.ad_hoc_charges = errors != null && errors.ad_hoc_charges ? errors.ad_hoc_charges : [];
    }
}

export class TradeQuoteItemModel implements ITradeQuoteItemModel {
    id: string;
    requirement: string;
    quantity: number;
    price_currency: string;
    price: number;
    negotiation_percent: number;
    min_manufacturing_year: number;
    max_manufacturing_year: number;
    pickup_ready_date: string;
    storage_charge_currency: string;
    storage_charge: number;
    free_storage_days: number;
    csc_revalidation_required: boolean;
    csc_revalidation_charge_currency: string;
    csc_revalidation_charge: number;
    csc_validation_included: boolean;
    is_procurement: boolean;
    created_by: CreatedBy;
    quote: string;
    color_preference: ColorPreference;
    container_size_type: ContainerSizeType;
    container_condition: ContainerCondition;
    purchase_locations: LocationModel[];
    container_images: UploadedDocument[];
    purpose: string;
    ad_hoc_charges?: QuoteChargeMaster[]

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.requirement = data != null ? data.requirement : null;
        this.quantity = data != null ? data.quantity : null;
        this.price_currency = data != null ? data.price_currency : 'USD';
        this.price = data != null ? data.price : null;
        this.storage_charge = data != null ? data.storage_charge : null;
        this.storage_charge_currency = data != null ? data.storage_charge_currency : 'USD';
        this.free_storage_days = data != null ? data.free_storage_days : null;
        this.csc_revalidation_required = data != null ? data.csc_revalidation_required : false;
        this.is_procurement = data != null ? data.is_procurement : false;
        this.csc_validation_included = data != null ? data.csc_validation_included : false;
        this.csc_revalidation_charge = data != null ? data.csc_revalidation_charge : null;
        this.csc_revalidation_charge_currency = data != null ? data.csc_revalidation_charge_currency : 'USD';
        this.negotiation_percent = data != null ? data.negotiation_percent : null;
        this.min_manufacturing_year = data != null ? data.min_manufacturing_year : null;
        this.max_manufacturing_year = data != null ? data.max_manufacturing_year : null;
        this.pickup_ready_date = data != null ? data.pickup_ready_date : null;
        this.color_preference = data != null ? data.color_preference : null;
        this.created_by = data != null ? data.created_by : null;
        this.quote = data != null ? data.quote : null;
        this.container_size_type = data != null ? data.container_size_type : new ContainerSizeType();
        this.container_condition = data != null ? data.container_condition : new ContainerCondition();
        this.purchase_locations = data != null ? data.purchase_locations : [];
        this.container_images = data != null ? data.container_images : [];
        this.purpose = data != null ? data.purpose : 'export';
        this.ad_hoc_charges = data != null ? data.ad_hoc_charges : [];
    }

    saveFirstPayload(data) {
        this.requirement = data.id;
        this.quantity = data.quantity;
        this.container_size_type = data.container_size_type;
        this.container_condition = data.condition;
    }

    setQuoteItemFromInternalRequestRequirement(int_requirement, int_request,default_currency) {
        this.requirement = int_requirement.id;
        this.quantity = int_requirement.quantity;
        this.container_size_type = int_requirement.container_size_type;
        this.container_condition = int_requirement.condition;
        this.csc_revalidation_required = int_requirement.csc_revalidation_required;
        this.purchase_locations = int_request != null ? int_request.pols : [];
        this.is_procurement = int_request != null ? int_request.is_procurement : false;
        this.purpose = int_requirement.purpose;
        this.storage_charge_currency = default_currency;
        this.price_currency = default_currency;
    }

    getTradeQuoteItemSavePayload() {
        let chargePayload = [];
        if (this.ad_hoc_charges.length != 0) {
            this.ad_hoc_charges.map(charge => {
                chargePayload.push({
                    quote_charge: charge.quote_charge.id,
                    amount: charge.amount,
                    amount_currency: charge.amount_currency
                })
            })
        }

        if (this.csc_revalidation_required) {
            return {
                requirement: this.requirement,
                quantity: this.quantity,
                price: this.price,
                price_currency: this.price_currency,
                negotiation_percent: this.negotiation_percent,
                min_manufacturing_year: this.min_manufacturing_year,
                max_manufacturing_year: this.max_manufacturing_year,
                pickup_ready_date: this.pickup_ready_date,
                storage_charge_currency: this.storage_charge_currency,
                storage_charge: this.storage_charge,
                free_storage_days: this.free_storage_days,
                csc_revalidation_required: this.csc_revalidation_required,
                csc_revalidation_charge_currency: this.csc_revalidation_charge_currency,
                csc_revalidation_charge: this.csc_revalidation_charge,
                csc_validation_included: this.csc_validation_included,
                is_procurement: this.is_procurement,
                color_preference: typeof this.color_preference == 'object' && this.color_preference != null ? this.color_preference.id : this.color_preference,
                quote: this.quote,
                container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
                container_condition: typeof this.container_condition == 'object' && this.container_condition != null ? this.container_condition.id : this.container_condition,
                purchase_locations: this.purchase_locations.map((item) => item.id),
                container_images: this.container_images.map((item) => item.id),
                purpose: this.purpose,
                ad_hoc_charges: chargePayload
            }
        } else {
            return {
                requirement: this.requirement,
                quantity: this.quantity,
                price: this.price,
                price_currency: this.price_currency,
                negotiation_percent: this.negotiation_percent,
                min_manufacturing_year: this.min_manufacturing_year,
                max_manufacturing_year: this.max_manufacturing_year,
                pickup_ready_date: this.pickup_ready_date,
                storage_charge_currency: this.storage_charge_currency,
                storage_charge: this.storage_charge,
                free_storage_days: this.free_storage_days,
                csc_revalidation_required: this.csc_revalidation_required,
                is_procurement: this.is_procurement,
                color_preference: typeof this.color_preference == 'object' && this.color_preference != null ? this.color_preference.id : this.color_preference,
                quote: this.quote,
                container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
                container_condition: typeof this.container_condition == 'object' && this.container_condition != null ? this.container_condition.id : this.container_condition,
                purchase_locations: this.purchase_locations.map((item) => item.id),
                container_images: this.container_images.map((item) => item.id),
                purpose: this.purpose,
                ad_hoc_charges: chargePayload
            }
        }
    }
}

export class TradeQuoteModel implements IBaseQuoteModel {
    id: string;
    request: string;
    quote_items: TradeQuoteItemModel[];
    quote_valid_till: Date;
    document: UploadedDocument;
    uploaded_documents: UploadedDocument[];
    remarks: string;
    quote_number: string;
    created_by: CreatedBy;
    terms_and_condition_text: string;
    terms_and_condition_fk: TermsAndConditionsModel;
    ad_hoc_charges?: QuoteChargeMaster[]

    error: TradeQuoteError;

    validations = {
        tentative_pickup_date: {
            minDate: new Date(),
        },
        negotiation_percent: {
            min: 0,
            max: 30,
        },
        max_manufacturing_year: {
            min: 1980,
            max: new Date().getFullYear(),
        },
        min_manufacturing_year: {
            min: 1980,
            max: new Date().getFullYear(),
        }
    }

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.request = data != null ? data.request : null;
        this.quote_items = [];
        let quote_valid_till = new Date();
        quote_valid_till.setDate(quote_valid_till.getDate() + 14);
        this.quote_valid_till = data != null ? data.quote_valid_till : quote_valid_till;
        this.document = data != null ? data.document : null;
        this.uploaded_documents = data != null ? data.uploaded_documents : [];
        this.remarks = data != null ? data.remarks : null;
        this.quote_number = data != null ? data.quote_number : null;
        this.created_by = data != null ? data.created_by : null;
        this.terms_and_condition_text = data != null ? data.terms_and_condition_text : null;
        this.terms_and_condition_fk = data != null ? data.terms_and_condition_fk : null;
        this.ad_hoc_charges = data != null ? data.ad_hoc_charges : [];

        this.error = new TradeQuoteError();

        if (data != null && data.quote_items.length != 0) {
            for (let i = 0; i < data.quote_items.length; i++) {
                this.quote_items[i] = new TradeQuoteItemModel(data.quote_items[i]);
                this.error.quote_items[i] = new TradeQuoteItemError();
            }
        } else {
            this.quote_items = [new TradeQuoteItemModel()];
        }
    }

    setDataFromInternalRequest(int_request,default_currency,tradeQuoteObj) {
        this.request = int_request != null ? int_request.id : null;
        this.quote_items = [];

        this.error = new TradeQuoteError();

        if (int_request != null && int_request.requirement.length != 0) {
            for (let i = 0; i < int_request.requirement.length; i++) {
                this.quote_items[i] = new TradeQuoteItemModel();
                this.quote_items[i].setQuoteItemFromInternalRequestRequirement(int_request.requirement[i], int_request,default_currency)
                this.error.quote_items[i] = new TradeQuoteItemError();
            }
        } else {
            this.quote_items = [new TradeQuoteItemModel()];
        }
    }

    getTradeQuoteSavePayload() {
        let chargePayload = [];
        if (this.ad_hoc_charges.length != 0) {
            this.ad_hoc_charges.map(charge => {
                chargePayload.push({
                    quote_charge: charge.quote_charge.id,
                    amount: charge.amount,
                    amount_currency: charge.amount_currency
                })
            })
        }

        return {
            request: this.request,
            quote_items: this.quote_items.map(item => item.getTradeQuoteItemSavePayload()),
            quote_valid_till: this.quote_valid_till,
            uploaded_documents: this.uploaded_documents.map((item) => item.id),
            remarks: this.remarks,
            terms_and_condition_text: this.terms_and_condition_text,
            terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
            ad_hoc_charges: chargePayload
        }
    }
}